import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isDelegationSessionStatusLoading } from 'domains/delegation/DelegationSession.store';
import { fetchDeliveryLeadTime } from 'domains/deliveryLeadTime/DeliveryLeadTime.store';
import { getUserRights, UserRole } from 'domains/user';
import { getData, hasUserAnyRight } from 'utils';

export const useFetchDeliveryLeadTime = (): void => {
  const dispatch = useDispatch();
  const userRights = useSelector(getUserRights);
  const isDelegationLoading = useSelector(isDelegationSessionStatusLoading);
  const hasRights = !hasUserAnyRight(
    [UserRole.COMMAND, UserRole.CONNECT_COMMANDE, UserRole.COUNTRY_ADMIN],
    getData(userRights) ?? [],
  );

  useEffect(() => {
    if (hasRights || isDelegationLoading) {
      return;
    }

    dispatch(fetchDeliveryLeadTime());
  }, [dispatch, hasRights, isDelegationLoading]);
};
